import { defineContent, type DefinedContent } from '@post-office/define-content';

export const registeredContent: DefinedContent<['header', 'cta', 'reasonsModalMessage']> =
	defineContent({
		default: {
			header: {
				id: 'growth.recommendation-loom.product-name.header',
				description: 'Header for Loom recommendation message in Jira Side Nav',
				defaultMessage: 'Record and share videos easily',
				role: 'title',
			},
			cta: {
				id: 'growth.recommendation-loom.cta.label',
				description: 'CTA text for Loom recommendation message in Jira Side Nav',
				defaultMessage: 'Try Loom',
			},
			reasonsModalMessage: {
				id: 'growth.recommendation-loom.reasons-modal.message',
				defaultMessage:
					"We think {product} will improve your team's productivity. The recommendation is based on:",
				description:
					'Explanation of why we think the Loom recommendation will be relevant to the customer.',
				role: 'description',
			},
		},
	});
